import { render } from "./TutorialModal.vue?vue&type=template&id=408c56c0&ts=true"
import script from "./TutorialModal.vue?vue&type=script&lang=ts"
export * from "./TutorialModal.vue?vue&type=script&lang=ts"

import "./TutorialModal.vue?vue&type=style&index=0&id=408c56c0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__